// usePedidosPDS.js — reemplazar la lógica de WebSocket
import { ref, onUnmounted } from "vue"
import { connectPDS, closePDS } from "@/utils/ws_peticiones.js"

export function usePedidosPDS() {
  const pedidos = ref([])
  const conectado = ref(false)
  const error = ref(null)

  function handleMessage(msg) {
    if (msg.tipo === "estado_inicial") {
      pedidos.value = msg.pedidos
      return
    }
    if (msg.tipo === "nuevo") {
      const existe = pedidos.value.find(p => p.numero_pedido === msg.pedido.numero_pedido)
      if (!existe) {
        pedidos.value.unshift(msg.pedido)
        reproducirSonido()
      }
      return
    }
    if (msg.tipo === "actualizar") {
      const idx = pedidos.value.findIndex(p => p.numero_pedido === msg.pedido.numero_pedido)
      if (idx !== -1) pedidos.value[idx] = msg.pedido
      else pedidos.value.unshift(msg.pedido)
      return
    }
    if (msg.tipo === "remover") {
      pedidos.value = pedidos.value.filter(p => p.numero_pedido !== msg.numero_pedido)
    }
  }

  function conectar() {
    connectPDS({
      onMessage: handleMessage,
      onOpen: () => { conectado.value = true; error.value = null },
      onClose: () => { conectado.value = false },
      onError: () => { error.value = "Error de conexión con el servidor" },
    })
  }

  // reproducirSonido() se queda igual que antes
  function reproducirSonido() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)()
      const VOLUMEN = 0.7

      // Chime Zoom: 3 notas ascendentes — Do, Mi, Sol (acorde mayor)
      const notas = [
        { freq: 523.25, inicio: 0 },      // Do5
        { freq: 659.25, inicio: 0.18 },   // Mi5
        { freq: 783.99, inicio: 0.36 },   // Sol5
      ]

      // Reverb simulado con un nodo de delay corto
      const convolver = ctx.createDelay(0.3)
      convolver.delayTime.value = 0.08
      const reverbGain = ctx.createGain()
      reverbGain.gain.value = 0.18
      convolver.connect(reverbGain)
      reverbGain.connect(ctx.destination)

      notas.forEach(({ freq, inicio }) => {
        const osc = ctx.createOscillator()
        const gain = ctx.createGain()

        osc.connect(gain)
        gain.connect(ctx.destination)
        gain.connect(convolver) // ← enviar al reverb también

        osc.type = "sine"
        osc.frequency.value = freq

        // Ataque rápido, decay largo — característico del chime de Zoom
        gain.gain.setValueAtTime(0, ctx.currentTime + inicio)
        gain.gain.linearRampToValueAtTime(VOLUMEN, ctx.currentTime + inicio + 0.015)
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + inicio + 1.2)

        osc.start(ctx.currentTime + inicio)
        osc.stop(ctx.currentTime + inicio + 1.3)
      })
    } catch (e) {
      console.warn("[PDS] Audio no disponible:", e)
    }
  }

  onUnmounted(closePDS)

  return { pedidos, conectado, error, conectar }
}